import React, { useCallback, useEffect, useState } from "react";
import styles from "css/mobile/mypage.module.css";
import { useTranslation } from "react-i18next";
import ScheduleCard from "components/mobile/mypage/ScheduleCard";
import moment from "moment";
import "css/menu.css";
import Input from "antd/es/input/Input";
import DetailResPop from "components/mobile/mypage/DetailResPop";
import DetailParticipantPop from "components/mobile/mypage/DetailParticipantPop";
import DetailEndpointPop from "components/mobile/mypage/DetailEndpointPop";
import ResPop from "components/mobile/mypage/ResPop";
import axios from "axios";
import { useDispatch } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import { useLocation } from "react-router-dom";

export default function CurrentSchedules() {
  const [type] = useState("current");
  const [isOpenRes, setIsOpenRes] = useState(false);
  const [isOpenResDetail, setIsOpenResDetail] = useState(false);
  const [isOpenParticipantDetail, setIsOpenParticipantDetail] = useState(false);
  const [isOpenEndpointDetail, setIsOpenEndpointDetail] = useState(false);
  const [init, setInit] = useState(true);
  const [schedules, setSchedules] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [keyword, setKeyword] = useState("");
  const dispatch = useDispatch();
  const { t } = useTranslation();
  moment.locale("en");
  const location = useLocation();
  console.log(location);

  // location.state.type = "card";

  const getSchedules = useCallback(() => {
    const startDate = new Date();
    const endDate = new Date(
      startDate.getTime() + 6 * 31 * 24 * 60 * 60 * 1000
    );
    console.log(keyword);
    let config = {
      params: {
        ACTIVE_START: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
        ACTIVE_END: moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
        CALENDAR_TYPE: "MY",
        KEY_WORD: keyword,
      },
    };

    axios
      .get("/schedule/detail", config)
      .then((res) => {
        if (res.status === 200) {
          setSchedules(res.data.SCHEDULE);
        }
      })
      .catch(() => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch, t, keyword]);

  const handleSearch = (value) => {
    setKeyword(value);
    setIsLoading(true);
    setInit(true);
  };

  useEffect(() => {
    if (isLoading) {
      getSchedules();
    }
  }, [getSchedules, isLoading]);

  const closeRes = () => {
    setIsOpenRes(false);
  };

  const closeResDetail = () => {
    setIsOpenResDetail(false);
  };

  const closeParticipantDetail = (e) => {
    e.stopPropagation();
    setIsOpenParticipantDetail(false);
  };

  const closeEndpointDetail = (e) => {
    e.stopPropagation();
    setIsOpenEndpointDetail(false);
  };

  return (
    <>
      <ResPop
        isOpenRes={isOpenRes}
        close={closeRes}
        schedule={{
          ...selectedSchedule,
          PROCESS_TYPE: "U",
        }}
        getScheduleList={getSchedules}
        PAGE_TYPE="calendar"
        RES_TYPE="general"
      />
      <DetailResPop
        isOpenResDetail={isOpenResDetail}
        closeResDetail={closeResDetail}
        schedule={selectedSchedule}
        type={type}
        refresh={handleSearch}
        openResPop={() => setIsOpenRes(true)}
      />
      <DetailParticipantPop
        isOpenParticipantDetail={isOpenParticipantDetail}
        closeParticipantDetail={closeParticipantDetail}
        participants={selectedSchedule.PARTICIPANT_LIST}
      />
      <DetailEndpointPop
        isOpenEndpointDetail={isOpenEndpointDetail}
        closeEndpointDetail={closeEndpointDetail}
        endpoints={selectedSchedule.ENDPOINT_LIST}
      />
      <div className={styles.container}>
        <div className={styles.searchArea}>
          <Input
            placeholder={t("PLACEHOLDER.SEARCH.TITLE_CONTENT_SHORT")}
            value={keyword}
            onChange={(e) => handleSearch(e.target.value)}
            className={styles.searchBox}
          />
        </div>
        <div className={styles.cardArea}>
          {isLoading ? (
            <div key="loading">{t("LABEL.PROCESS_DATA")}</div>
          ) : (
            <>
              {schedules.length === 0 && (
                <div key="no-data">{t("MESSAGE.NO_DATA")}</div>
              )}
              {schedules.length > 0 &&
                schedules.map((schedule, index) => {
                  const currentDate = schedule.START_DATE;
                  const prevDate =
                    index > 0 ? schedules[index - 1].START_TIME : null;
                  const isDateDivider = currentDate !== prevDate;

                  return (
                    <div key={schedule.SCHEDULE_ID}>
                      {isDateDivider && (
                        <div className={styles.dateLabel}>
                          {moment(currentDate).format("YY.MM.DD ddd")}
                        </div>
                      )}
                      <ScheduleCard
                        schedule={schedule}
                        type="current"
                        refresh={handleSearch}
                        setSelectedSchedule={setSelectedSchedule}
                        setIsOpenResDetail={setIsOpenResDetail}
                        setIsOpenParticipantDetail={setIsOpenParticipantDetail}
                        setIsOpenEndpointDetail={setIsOpenEndpointDetail}
                      />
                    </div>
                  );
                })}
            </>
          )}
        </div>
      </div>
    </>
  );
}
